import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

const useProjectMapAllowed = () => {
	const hasFeature = useFeatureAvailable(Feature.PROJECT_PLAN);
	return hasFeature;
};

export default useProjectMapAllowed;
